<template>
  <div class="query">
    <div class="query__title">BladeX 授权商用企业查询</div>
    <div class="query__search">
      <el-input placeholder="请输入完整授权编号查询(未收录或需要展示全名请联系作者)"
                @keyup.enter.native="handelSearch"
                v-model="value">
        <el-button type="primary"
                   slot="append"
                   @click="handelSearch">查询
        </el-button>
        <el-button type="primary"
                   slot="append"
                   @click="handelReset">重置
        </el-button>
      </el-input>
    </div>
    <div class="query__content"
         v-if="!validatenull(baseList)">
      <el-card class="query__text"
               v-for="(obj,index) in baseList"
               :key="index">
        <h3 slot="header">{{obj.zsmc || '客户要求不展示名称'}}</h3>
        <p>授权编号：{{obj.compid}}</p>
        <p>授权日期：{{obj.datetime}}</p>
      </el-card>
    </div>
    <div class="query__content">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="this.page.currentPage"
        :total="this.page.total"
        @current-change="currentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import Record from '@/util/record';

  export default {
    data() {
      return {
        value: '',
        baseList: [],
        page: {
          currentPage: 1,
          total: 0,
          pageSize: 10
        }
      }
    },
    created() {
      this.getList();
    },
    methods: {
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
        this.getList();
      },
      handelSearch() {
        this.page.currentPage = 1;
        this.getList();
      },
      handelReset() {
        this.value = '';
        this.handelSearch();
      },
      getList() {
        const query = new Record('x_ticket');
        query.select("zsmc,compid,datetime");
        query.equalTo("compid", "<>", "''");
        query.limit(10);
        if (this.value) {
          query.equalTo("compid", "=", `'${this.value.toUpperCase()}'`);
        }
        query.count().then(res => {
          this.page.total = res.data;
          const next = (this.page.currentPage - 1) * this.page.pageSize;
          query.limit(this.page.pageSize);
          query.skip(next);
          query.order("compid");
          query.find().then(res => {
            this.baseList = res.data.sort(function (x, y) {
              if (x.compid < y.compid) {
                return -1;
              } else if (x.compid > y.compid) {
                return 1;
              } else {
                return 0;
              }
            });
            this.baseList = this.baseList.filter(ele => {
              ele.datetime = new Date(ele.datetime).Format("yyyy.MM.dd");
              return ele.compid
            })
          });
        });
      }
    }
  };
</script>

<style lang="scss">
  .query {
    padding-top: 150px;
    min-height: 500px;
    height: auto;

    &__title {
      width: 100%;
      font-size: 42px;
      text-align: center;
      font-weight: 600;
    }

    &__search {
      width: 600px;
      margin: 60px auto 0 auto;
    }

    &__content {
      width: 100%;
      margin: 30px 0;
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      justify-content: center;
    }

    &__text {
      box-sizing: border-box;
      margin: 15px 10px 0 10px;
      width: 40%;

      p {
        line-height: 30px;
      }
    }
  }
</style>
